
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design",
      function () {
        return require("private-next-pages/design/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design"])
      });
    }
  